import React from "react";
import Image from "next/image";
import DemoButton from "../Demo/DemoButton";
import CustomButton from "../Buttons/CustomButton";
import slider1 from "@/Helper/images/slider/fitness/slider1.png";
import Link from "next/link";

const Fitness = () => {
  return (
    <div className="industry_container">
      <div className="industry_left_content">
        <p className="heading">
          Enhance public safety concerns with AI technology
        </p>
        <p className="subheading">
          AI in government processes enables seamless traffic flow analysis,
          improving healthcare solutions, processing large volumes of data, &
          advanced infrastructure monitoring.
        </p>

        <div className="btn_container">
          <DemoButton PrimaryColorBtn />

          <Link href={"/public-sector"}>
            <CustomButton Text={"View More"}></CustomButton>
          </Link>
        </div>
      </div>
      <div className="industry_right_content">
        <div className="slider_bg normal_bg">
          <Image
            src={slider1}
            alt="Enhance public safety concerns with AI technology"
            width={459}
            height={253}
            className="productbanner_imageslider"
            loading="eager"
          />
        </div>
      </div>
    </div>
  );
};

export default Fitness;
